module.exports = __webpack_public_path__ + "media/next_game_start_5.f64de702.mp3";